// Keyboard helpers shared by the header's two dropdown panels (AccountMenu, GetStartedMenu).

/** The links and enabled buttons inside `root`, in document order. */
export const focusables = (root) => (root ? [...root.querySelectorAll('a[href], button:not([disabled])')] : []);

/**
 * onKeyDown for an open panel: ArrowDown / ArrowUp move to the next / previous item
 * (wrapping), Home / End to the first / last. Tab is left alone (it moves on through the
 * items and out of the panel, which closes it: useDismiss).
 */
export function onPanelKeyDown(e) {
  const items = focusables(e.currentTarget);
  const i = items.indexOf(document.activeElement);
  let next = null;
  if (e.key === 'ArrowDown') next = items[(i + 1) % items.length];
  else if (e.key === 'ArrowUp') next = items[(i - 1 + items.length) % items.length];
  else if (e.key === 'Home') [next] = items;
  else if (e.key === 'End') next = items[items.length - 1];
  if (next) {
    e.preventDefault();
    next.focus();
  }
}
